import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { UtenteService } from 'src/app/services/utente.service';

@Component({
  selector: 'app-registra-dati-utente',
  standalone: true,
  templateUrl: './registra-dati-utente.component.html',
  styleUrls: ['./registra-dati-utente.component.scss'],
  imports: [ReactiveFormsModule]
})
export class RegistraDatiUtenteComponent implements OnInit {

  form: FormGroup;

  constructor(private service: UtenteService) {
    this.form = new FormGroup({
      nome: new FormControl(null, { validators: [Validators.required,], updateOn: 'submit' }),
      cognome: new FormControl(null, { validators: [Validators.required,], updateOn: 'submit' }),
      cf: new FormControl(null, { validators: [Validators.required,], updateOn: 'submit' }),
      news: new FormControl(null, { validators: [Validators.required,], updateOn: 'submit' }),
      indirizzo: new FormControl(null, { validators: [Validators.required,], updateOn: 'submit' }),
     
    });
  }
  ngOnInit(): void {
  }
  get nome(): AbstractControl {
    return this.form.get('nome')!;
  }
  get cognome(): AbstractControl {
    return this.form.get('cognome')!;
  }
  get cf(): AbstractControl {
    return this.form.get('cf')!;
  }
  onSubmit(): void {
    this.form.markAllAsTouched();
    this.registraDati()
  }
  registraDati(){
    this.service.registraDatiUtente(this.form.value).subscribe(
      (ut:any)=>{
        if(ut['error']){
          alert('errore')
        }else{
          this.service.setUtente(ut['res'])
        }
      }
    )
  }
}
